import { API_URL, Status } from '../constants';
import { fetch } from '../fetchWrapper/fetch';
import { IIngestDiffResponse } from './types';

export const getIngestDiff = async (eventId: string): Promise<IIngestDiffResponse | null> => {
  const res = await fetch(`${API_URL}/ingest/diff/${eventId}`);

  if (res.status === Status.NOT_FOUND) return null;
  if (!res.ok) throw new Error(`Could not get sync changes: ${res.status}`);

  return res.json();
};
